<script lang="ts" setup>
import BaseDialog from '@/components/dialogs/BaseDialog.vue'

defineProps<{
  loading: boolean
}>()

const emit = defineEmits<{
  (event: 'action' | 'close'): void
}>()

const { t } = useI18n()
</script>

<template>
  <base-dialog
    data-cy="batchDeleteDialog"
    max-width="632"
    :title="t('remove_observer.self_remove.dialog.title')"
    :disabled="loading"
    :loading="loading"
    :action-text="t('remove_observer.self_remove.dialog.remove')"
    action-color="error"
    :cancel-text="t('global.cancel')"
    @action="emit('action')"
    @close="emit('close')"
  >
    <div class="pb-4">{{ t('remove_observer.self_remove.dialog.subtitle') }}</div>
  </base-dialog>
</template>
